import { fetchData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN, CAMPAIGNv3 } from './mediaPlanning';
import { CountryFormState } from '../../../store/planStore';

export interface PlanResponseData {
  campaignName: string;
  division: string;
  brand: string;
  category: string;
  id: string;
  countrySetup: Record<string, CountryFormState>;
}
export const getPlanById = async (id: string) => {
  return fetchData<ApiResponse<PlanResponseData>>(
    `/${CAMPAIGN}/media-plans/${id}`
  );
};
